module.exports = __webpack_public_path__ + "img/chevron.92f6ff6a.svg";